import { render, staticRenderFns } from "./PopupTranDetail2.vue?vue&type=template&id=9d972658&scoped=true"
import script from "./PopupTranDetail2.vue?vue&type=script&lang=js"
export * from "./PopupTranDetail2.vue?vue&type=script&lang=js"
import style0 from "./PopupTranDetail2.vue?vue&type=style&index=0&id=9d972658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d972658",
  null
  
)

export default component.exports